import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setFromPaywallResponse } from "../../redux/readerSlice";
import ErrorPage from "../ErrorPage";
import PageLoader from "../PageLoader";

const PaywallPing = ({ dashboard, children }) => {
    const dispatch = useDispatch();
    const [initialized, setInitialized] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(process.env.REACT_APP_MYSKIFT_API_ROOT + '/public/paywall', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ 
                payload: dashboard.paywall_payload, 
                send_access_token: true,
                url: window.location.href,
                host: window.location.host,
                title: document.title
            }),
            credentials: 'include'
        })
        .then(response => {
            if (!response.ok) {
                // Manually throw an error so it gets caught in the catch block
                return response.text().then(text => {
                    throw new Error(`HTTP ${response.status}: ${text}`);
                });
            }
            return response.json();
        })
        .then(data => {
            dispatch(setFromPaywallResponse(data));
            setInitialized(true);
        })
        .catch(error => {
            setError(error);
            setInitialized(true);
        });
    }, [dashboard, dispatch]);

    if (error) {
        return <ErrorPage />;
    }

    if (!initialized) {
        return <PageLoader />;
    }

    return children;
};

export default PaywallPing;